import { ServiceReport, ServiceReportValidationError } from "../../types";
import stripEmptyObjectProp from "../../utils/stripEmptyObjectProp";
import { validateBranchCode } from "../../utils/validators/validateBranchCode";
import validateDate from "../../utils/validators/validateDate";
import validateEntityName from "../../utils/validators/validateEntityName";
import validateTitle from "../../utils/validators/validateTitle";

export const validateServiceReport = (service: ServiceReport) => {
   let errors = {} as ServiceReportValidationError;

   errors.branchCode = validateBranchCode(service.branchCode);
   errors.serviceDate = validateDate(service.serviceDate, { optional: false });
   errors.name = validateEntityName(service.name, "Service name");
   errors.sermonTitle = validateTitle(service.sermonTitle);

   return stripEmptyObjectProp(errors);
};
